<div class="project-data-step-container">
  <dx-form class="gpd-form" [formData]="projectData" [validationGroup]="validationGroup" [showColonAfterLabel]="false" [colCount]="1">
    <dxi-item dataField="nr" isRequired="true">
      <dxo-label i18n-text="@@number" text="Number"></dxo-label>
      <dx-text-box class="gpd-input" [(value)]="projectData.nr" [maxLength]="5" [width]="150" validation="">
        <dx-validator>
          <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
          <dxi-validation-rule type="pattern" pattern="^[0-9]+$" i18n-message="@@onlyNumbers" message="Only numbers are allowed"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </dxi-item>

    <dxi-item dataField="name" isRequired="true">
      <dxo-label i18n-text="@@name" text="Name"></dxo-label>
      <dx-text-box class="gpd-input" [(value)]="projectData.name" [maxLength]="50" valueChangeEvent="input">
        <dx-validator>
          <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
          <dxi-validation-rule
            type="pattern"
            pattern="^[a-zA-ZäöüÄÖÜß0-9_ \-\(\)\[\]\{\}]+$"
            i18n-message="@@namePatternValidation"
            message="Name can only contain letters, numbers, underscores and hyphens"
          ></dxi-validation-rule>
          <dxi-validation-rule
            type="stringLength"
            [min]="3"
            [max]="50"
            i18n-message="@@projectNameLengthValidation"
            message="Name must be between 3 and 50 characters"
          ></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </dxi-item>

    <dxi-item dataField="areaTypeId" isRequired="true">
      <dxo-label i18n-text="@@areaType" text="Area Type"></dxo-label>
      <dx-select-box
        class="gpd-input"
        [dataSource]="areaTypes"
        displayExpr="name"
        valueExpr="id"
        [(value)]="projectData.areaTypeId"
        (onValueChanged)="onAreaTypeChanged($event.value)"
      >
        <dx-validator>
          <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
        </dx-validator>
      </dx-select-box>
    </dxi-item>

    <dxi-item dataField="startDate" isRequired="true">
      <dxo-label i18n-text="@@startDate" text="Start Date"></dxo-label>
      <gpd-datebox
        class="gpd-input"
        [(value)]="projectData.startDate"
        (onValueChanged)="onStartDateChanged($event.value)"
        [validationRules]="[{ type: 'required' }]"
      >
      </gpd-datebox>
    </dxi-item>

    <dxi-item dataField="partner">
      <dxo-label i18n-text="@@partner" text="Partner"></dxo-label>
      <div class="contacts-dropdown-box-container" *dxTemplate>
        <app-contacts-dropdown-box
          [style.width]="'100%'"
          [contactId]="$safeNavigationMigration(projectData.partner?.id)"
          [contactType]="$safeNavigationMigration(projectData.partner?.contactType)"
          [companies]="companies"
          [persons]="persons"
          (onContactSelected)="onPartnerChanged($event)"
          (onNewContactRequested)="onNewContactFromDropdown($event, 'partner')"
        >
        </app-contacts-dropdown-box>
      </div>
    </dxi-item>

    <dxi-item dataField="epc">
      <dxo-label i18n-text="@@epcCaps" text="EPC"></dxo-label>
      <div class="contacts-dropdown-box-container" *dxTemplate>
        <app-contacts-dropdown-box
          [style.width]="'100%'"
          [contactId]="$safeNavigationMigration(projectData.epc?.id)"
          [contactType]="$safeNavigationMigration(projectData.epc?.contactType)"
          [companies]="companies"
          [persons]="persons"
          (onContactSelected)="onEpcChanged($event)"
          (onNewContactRequested)="onNewContactFromDropdown($event, 'epc')"
        >
        </app-contacts-dropdown-box>
      </div>
    </dxi-item>
  </dx-form>
</div>

<app-contacts-popup
  [(visible)]="contactPopupTarget"
  (onHiding)="contactPopupTarget = null"
  [(companies)]="companies"
  [(persons)]="persons"
  (onContactSelected)="onContactSelected($event)"
  (onContactAdded)="onContactAdded($event)"
  width="100px"
  height="auto"
>
</app-contacts-popup>
